import { AdminAction } from './admin'
import { AppAction } from './app'

const adminAction = new AdminAction()
const appAction = new AppAction()

export {
    adminAction, appAction
}


// WEBPACK FOOTER //
// ./src/actions/index.jsx